import { createFileRoute } from '@tanstack/react-router'
import { SupplierReturnsListPage } from '../../../features/purchasing/returns-list-page'
import { returnSearchSchema } from '../../../features/purchasing/search'

export const Route = createFileRoute('/_app/supplier-returns/')({
  validateSearch: returnSearchSchema,
  component: SupplierReturnsListPage,
})
